import { socialApi } from "@bw/shared/api";
import { invalidateFeedQueries } from "@bw/shared/hooks";
import type { BlockedUserResponse } from "@bw/shared/types/generated";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { queryKeys } from "../../../common/query/queryClient";

/** Server-minimized blocked-user recovery list with row-scoped unblock. */
export function useBlockedUsers() {
  const blockedUsers = useQuery<BlockedUserResponse[]>({
    queryKey: queryKeys.social.blockedUsers(),
    queryFn: () => socialApi.getBlockedUsers(),
  });

  return { blockedUsers };
}

/** A distinct mutation observer per row keeps overlapping recovery state local. */
export function useUnblockPlayer(userId: string) {
  const queryClient = useQueryClient();
  return useMutation<void, unknown, void>({
    mutationFn: () => socialApi.unblock(userId),
    onSuccess: () => {
      // Unblock can restore the reachability of graph, search, and conversation
      // reads. One prefix invalidation includes this list and the selected
      // status key without maintaining a second client-side graph truth.
      void queryClient.invalidateQueries({ queryKey: queryKeys.social.all });
      invalidateFeedQueries(queryClient);
    },
  });
}
